import {
  BestPerforming,
  DragScrollX,
  Div,
  getDashboardBestPerformingFleetsDeliveries,
  getDashboardBestPerformingLocationsDeliveries,
  getDashboardBestPerformingStatesDeliveries,
  getDashboardWorstPerformingLocationsDeliveries,
  H3,
  ImproveWithAILocation,
} from '@vgrubs/components';
import { useState } from 'react';
import { LocationStrategySuggestion } from './LocationStrategySuggestion';
import { SuccessRateSection } from './SuccessRateSection';
import { SuccessTrackingRateSection } from './SuccessTrackingRateSection';

export const LifetimePerformance = () => {
  // The last location asked about stays mounted after its modal closes, so
  // its AI run keeps polling; another row swaps it (keyed on the id).
  const [aiLocation, setAiLocation] = useState<ImproveWithAILocation | null>(
    null
  );
  const [aiOpen, setAiOpen] = useState(false);

  return (
    <Div>
      <Div $column>
        <H3 $mb="10">Lifetime Performance</H3>
      </Div>
      <DragScrollX>
        <BestPerforming
          title="Best Performing States"
          getFunction={getDashboardBestPerformingStatesDeliveries}
        />
        <BestPerforming
          title="Best Performing Fleets"
          getFunction={getDashboardBestPerformingFleetsDeliveries}
          vDrive
        />
        <BestPerforming
          title="Best Performing Locations"
          getFunction={getDashboardBestPerformingLocationsDeliveries}
          link="/locations"
        />
        <BestPerforming
          title="Worst Performing Locations"
          getFunction={getDashboardWorstPerformingLocationsDeliveries}
          link="/locations"
          onImproveWithAI={(location) => {
            setAiLocation(location);
            setAiOpen(true);
          }}
        />
        <SuccessRateSection />
        <SuccessTrackingRateSection />
      </DragScrollX>
      {aiLocation && (
        <LocationStrategySuggestion
          key={aiLocation.id}
          location={aiLocation}
          isOpen={aiOpen}
          closeModal={() => setAiOpen(false)}
        />
      )}
    </Div>
  );
};
